/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_RevenueInputs */

const en_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const ar_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#إيرادات`)
};

const bn_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const de_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const es_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const fr_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const pt_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const zh_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const tr_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const ru_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

const pl_svtag_revenue = /** @type {(inputs: Svtag_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#REVENUE`)
};

/**
* | output |
* | --- |
* | "#REVENUE" |
*
* @param {Svtag_RevenueInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_revenue = /** @type {((inputs?: Svtag_RevenueInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_RevenueInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_revenue(inputs)
	if (locale === "bn") return bn_svtag_revenue(inputs)
	if (locale === "de") return de_svtag_revenue(inputs)
	if (locale === "es") return es_svtag_revenue(inputs)
	if (locale === "fr") return fr_svtag_revenue(inputs)
	if (locale === "pt") return pt_svtag_revenue(inputs)
	if (locale === "zh") return zh_svtag_revenue(inputs)
	if (locale === "tr") return tr_svtag_revenue(inputs)
	if (locale === "ru") return ru_svtag_revenue(inputs)
	if (locale === "pl") return pl_svtag_revenue(inputs)
	return en_svtag_revenue(inputs)
});